import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { getResetStateMutation } from "@/store/helpers/helpers";

const getDefaultState = () => ({
  roomMessages: [],
  tableMessages: [],
  unreadMessagesCounter: {
    TABLE: 0,
    PRIVATE: 0
  },
  chatMode: "TABLE", // TABLE or PRIVATE
  privateMessages: [],
  privateChatTarget: null,
  privateChatTargetUsers: [],
  privateChatFilters: {
    NETWORK: true,
    OTHER: true
  }
});

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    resetState: getResetStateMutation(getDefaultState)
  },
  actions,
  getters
};
